import React, { useState, useEffect, useRef } from "react";

// Model Layout Component - ClimateChange
const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const climateLayers = [
  {
    id: "ccm1",
    src: "/assets/svgs/climate-change-svgs/mobile-svgs/ccm1.svg",
    alt: "climate change",
    style: { left: "12%", top: "42%" },
  },
  {
    id: "ccm2",
    src: "/assets/svgs/climate-change-svgs/mobile-svgs/ccm2.svg",
    alt: "climate change",
    style: { left: "55%", top: "61.4%", zIndex: 40 },
  },
  {
    id: "ccm3",
    src: "/assets/svgs/climate-change-svgs/mobile-svgs/ccm3.svg",
    alt: "climate change",
    style: { left: "19%", top: "78%" },
  },
  {
    id: "ccm4",
    src: "/assets/svgs/climate-change-svgs/mobile-svgs/ccm4.svg",
    alt: "climate change",
    style: { left: "65%", top: "48.7%", zIndex: 30 },
  },
  {
    id: "ccm5",
    src: "/assets/svgs/climate-change-svgs/mobile-svgs/ccm5.svg",
    alt: "climate change",
    style: { left: "65.5%", top: "32.7%", zIndex: 20 },
  },
  {
    id: "ccm6",
    src: "/assets/svgs/climate-change-svgs/mobile-svgs/ccm6.svg",
    alt: "climate change",
    style: { left: "46.5%", top: "16.1%", zIndex: 10 },
  },
];

const ClimateChangeMobileModel = ({
  className = "",
  showTooltips = true,
  isParentLoading = false,
  isPopUpOpen = false,
}) => {
  const [shouldJiggle, setShouldJiggle] = useState(false);
  const jiggleTriggeredRef = useRef(false);

  useEffect(() => {
    if (!isParentLoading && !isPopUpOpen && !jiggleTriggeredRef.current) {
      jiggleTriggeredRef.current = true;
      const timer = setTimeout(() => {
        setShouldJiggle(true);
        const stopTimer = setTimeout(() => {
          setShouldJiggle(false);
        }, 1500);
        return () => clearTimeout(stopTimer);
      }, 600); // Starts slightly after loader/popup clears
      return () => clearTimeout(timer);
    }
  }, [isParentLoading, isPopUpOpen]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      ccm6: "care-sector",
      ccm5: "india",
      ccm4: "bangladesh",
      ccm2: "indonesia",
      ccm3: "nepal",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-8">
      <section className="p-2">
        <div
          className={`relative mx-auto aspect-[4/7] max-w-[500px] ${className}`}
        >
          {climateLayers.map((layer) => {
            const interactive = layer.id !== "ccm1";
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const tooltipPos = (() => {
              switch (layer.tooltipPlacement) {
                case "left":
                  return "left-full top-[4%] -translate-y-1/2 ml-2";
                case "left-center":
                  return "left-full top-1/2 -translate-y-1/2 ml-2";
                case "left-top":
                  return "left-[73%] top-[-6%] -translate-y-1/2 ml-2";
                case "right":
                  return "right-[96%] top-[89%] -translate-y-1/2 mr-2";
                case "top":
                  return "bottom-full left-1/2 -translate-x-1/2 -mt-2";
                default:
                  return "top-full left-1/2 -translate-x-1/2 mt-2";
              }
            })();

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className={`absolute -translate-x-1/2 -translate-y-1/2 ${
                  interactive ? "group" : ""
                }`}
                style={layer.style}
              >
                <div className="relative">
                  <div className={interactive && shouldJiggle ? "animate-jiggle" : ""}>
                    <img
                      src={layer.src}
                      alt={layer.alt}
                      loading="lazy"
                      className={`select-none max-w-max object-contain ${
                        interactive
                          ? "map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                          : "pointer-events-none"
                      }`}
                      style={interactive ? { ...hoverTiming } : undefined}
                      {...(interactive ? bounceHandlers : {})}
                      {...(handleClick ? { onClick: handleClick } : {})}
                    />
                  </div>
                  {interactive && layer.tooltip && showTooltips && (
                    <span
                      className={`pointer-events-none z-50 absolute rounded-md bg-[#FEFBF6] p-2 text-[11px] font-normal text-black text-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100 ${tooltipPos}`}
                    >
                      {layer.tooltip}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default ClimateChangeMobileModel;
